import { ORDER_DETAIL_FRAGMENT } from './order';
import { ERROR_RESULT_FRAGMENT } from './shared';

export const SET_RTO_APP_FIELDS = /* GraphQL */ `
mutation SetRtoAppFields($input: RtoAppFieldsInput!) {
    setRtoAppFields(input: $input) {
        ...OrderDetail
    }
    ${ORDER_DETAIL_FRAGMENT}
}
`;

export const SET_RTO_FIELDS = /* GraphQL */ `
mutation SetRtoFields($input: RtoFieldsInput!) {
    setRtoFields(input: $input) {
        ...OrderDetail
    }
    ${ORDER_DETAIL_FRAGMENT}
}
`;

export const SET_RTO_ITEM = /* GraphQL */ `
mutation SetRtoItem($input: RtoItemInput!) {
    setRtoItem(input: $input) {
        ...OrderDetail
    }
    ${ORDER_DETAIL_FRAGMENT}
}
`;

export const SET_RTO_CUSTOMER = /* GraphQL */ `
mutation SetRtoCustomer($input: RtoCustomerInput!) {
    setRtoCustomer(input: $input) {
        ...OrderDetail
    }
    ${ORDER_DETAIL_FRAGMENT}
}
`;

export const GET_RTO_PAYMENT_ESTIMATE = /* GraphQL */ `
    query GetRtoPaymentEstimate($options: RtoPaymentEstimateOptions!) {
        rtoPaymentEstimate(options: $options) {
            term
            basePayment
            initialPayment
            recurringPayment
            ldwPrice
            ldw
            tax
            taxRate
            requiredPaymentsDown
            greaterPaymentOptions
        }
    }
`;

export const RTO_ORDER_FORM_DATA = /* GraphQL */ `
    query GetRtoOrderFormData($orderId: ID!) {
        order(id: $orderId) {
            ...OrderDetail
        }
        rtoTermsForOrder(orderId: $orderId) {
            term
            originalInitialPayment
            originalBasePayment
            originalRecurringPayment
            originalTax
            basePayment
            initialPayment
            netInitialPayment
            recurringPayment
            ldwPrice
            ldw
            tax
            taxRate
            requiredPaymentsDown
            greaterPaymentOptions
            enableSecurityDeposit
        }
        rtoConfig
        ${ORDER_DETAIL_FRAGMENT}
    }
`;

export const FINALIZE_CONTRACT = /* GraphQL */ `
mutation FinalizeContract($input: FinalizeContractInput!) {
    finalizeContract(input: $input) {
        redirectUrl
    }
}
`;

export const GET_RTO_CONFIG = /* GraphQL */ `
query GetRtoConfig {
    rtoConfig
}
`;

export const PROCESS_PAYMENT = /* GraphQL */`
    mutation ProcessPayment($input: ProcessPaymentInput!) {
        processPayment(input: $input) {
            ...OrderDetail
            ...ErrorResult
        }
    }
    ${ORDER_DETAIL_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;

export const UPLOAD_ATTACHMENT = /* GraphQL */`
    mutation UploadAttachment($orderId: String!, $file: Upload!) {
        uploadAttachment(orderId: $orderId, file: $file) {
            ...OrderDetail
        }
    }
    ${ORDER_DETAIL_FRAGMENT}
`;
